<template>
  <section>
    <div class="container">
      <h2 class="text-center">Here's How You Can Help!</h2>
      <div class="cta">
        <div class="module">
          <img class="icon" src="~assets/images/PFK_Icon_DonateHand.svg">
          <p>Your Donation</p>
        </div>
        <div class="module">
          <img class="icon" src="~assets/images/PFK_Icon_Backpack.svg">
          <p>Gives backpacks with school supplies &amp; uniforms</p>
        </div>
        <div class="module">
          <img class="icon" src="~assets/images/PFK_Icon_GraduationCap.svg">
          <p>Supports education for kids in developing countries</p>
        </div>
      </div>
      <div class="text-center"><router-link to="/#donate" class="btn btn-lg btn-primary">Donate Now</router-link></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'how-to-help'
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 80px 0;
}

.cta {
  margin: 3rem auto;

  @include media('tablet') {
    display: flex;
    justify-content: space-around;
    max-width: 920px;
  }

  .module {
    width: 270px;
    text-align: center;
    position: relative;
    margin: auto;

    .icon {
      width: 100px;
      height: 100px;
    }

    p {
      margin: 1em 0 0;
      text-transform: uppercase;
      font-weight: 900;
      letter-spacing: 1px;
      line-height: 1.5;
    }

    &:after {
      content: '=';
      font-family: $hand;
      font-size: 5rem;
      position: relative;
      display: inline-block;
      color: $brand-primary;
      margin: 30px auto;
      line-height: 34px;

      @include media('tablet') {
        position: absolute;
        height: 34px;
        line-height: 20px;
        top: 30%;
        transform: translateY(-50%);
        right: -40px;
        left: auto;
      }
    }

    &:last-child {
      &:after {
        content: none;
      }
    }
  }
}

.holiday-drive {
  margin: 0 0 3rem;

  .btn {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// HowToHelp.vue?3dd0a3a8